import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingFooter() {
  const navigate = useNavigate();
  return (
    <footer className="bg-[#050505] text-zinc-300 py-24 px-4 sm:px-6 lg:px-8 border-t border-zinc-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Flipping Friends</h3>
            <p className="text-zinc-400 mb-4">Built by resellers, for resellers.</p>
            <div className="space-y-2 text-sm">
              <p>📧 Contact: <a href="mailto:marcus@flippingfriends.co.uk" className="hover:text-[#00D26A] transition-colors">marcus@flippingfriends.co.uk</a></p>
              <p>📱 Marcus: 07375 084884</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm mb-6">
              <li>
                <button onClick={() => navigate('/contact')} className="text-zinc-400 hover:text-[#00D26A] transition-colors" data-testid="footer-contact-btn">
                  Contact Us
                </button>
              </li>
              <li><a href="#waitlist" className="text-zinc-400 hover:text-[#00D26A] transition-colors">Join Beta Waitlist</a></li>
              <li><a href="#founding-100" className="text-zinc-400 hover:text-[#FFD700] transition-colors">Founding 100 (VIP)</a></li>
            </ul>

            <h4 className="text-lg font-semibold text-white mb-4">Follow Development</h4>
            <ul className="space-y-2 text-sm">
              <li>
                • Facebook:{' '}
                <a
                  href="https://www.facebook.com/share/19gzSE543z/?mibextid=wwXIfr"
                  target="_blank" rel="noopener noreferrer"
                  className="text-[#00D26A] hover:text-[#FFD700] ml-2 underline transition-colors"
                >
                  @FlippingFriendsUK
                </a>
              </li>
              <li>• Reddit: r/FlippingUK</li>
              <li>• Twitter: @FlippingFriendsUK (coming soon)</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8">
          <div className="bg-gradient-to-r from-[#00D26A]/10 to-[#FFD700]/10 border border-zinc-800/50 rounded-2xl p-6 mb-8">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-lg font-semibold text-white mb-3">Built with Emergent AI</h3>
              <p className="text-zinc-300 text-sm mb-4 leading-relaxed">
                "Emergent's AI-powered development platform enabled us to build Flipping Friends rapidly without compromising on quality.
                I'd confidently recommend it to any founder looking to create professional products for their business.
                The platform is intuitive, powerful, and accelerates development dramatically."
              </p>
              <a
                href="https://app.emergent.sh/register?ref=barr025365"
                target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#00D26A] to-[#FFD700] hover:opacity-90 text-black rounded-full transition-all text-sm font-bold shadow-[0_0_20px_rgba(0,210,106,0.2)]"
              >
                Try Emergent (Referral Link)
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>

          <div className="text-center text-sm text-zinc-500">
            <p>© 2026 Flipping Friends. All rights reserved.</p>
            <p className="mt-2 space-x-3">
              <button
                onClick={() => navigate('/privacy')}
                className="hover:text-[#00D26A] transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </button>
              <span className="text-zinc-700">|</span>
              <button
                onClick={() => navigate('/terms')}
                className="hover:text-[#00D26A] transition-colors"
                data-testid="footer-terms-link"
              >
                Terms of Service
              </button>
              <span className="text-zinc-700">|</span>
              <button
                onClick={() => navigate('/community-guidelines')}
                className="hover:text-[#00D26A] transition-colors"
                data-testid="footer-community-link"
              >
                Community Guidelines
              </button>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
